import { Injectable, Injector, Type } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BaseNotificationModalComponent } from './base-notification-modal/base-notification-modal.component';
import { MODAL_DATA } from './tokens/modal-data.token';

@Injectable()
export class ModalService {
  private ngbModalService: NgbModal;

  constructor(private readonly injector: Injector) {}

  public init() {
    this.ngbModalService = this.injector.get(NgbModal);
  }

  openModalWithInjectData<T = {}>(
    modalComponent: Type<{}>,
    data: T,
    windowClass: string = 'notification-modal',
    ariaLabelledBy?: string
  ): NgbModalRef {
    const modalRef = this.ngbModalService.open(BaseNotificationModalComponent, {
      backdrop: 'static',
      keyboard: false,
      windowClass: windowClass,
      ariaLabelledBy,
      injector: Injector.create({
        providers: [
          {
            provide: MODAL_DATA,
            useValue: {
              modalComponent,
              data,
            },
          },
        ],
      }),
    });
    return modalRef;
  }

  public open(modalComponent: any, options?: NgbModalOptions) {
    const modalRef = this.ngbModalService.open(modalComponent, options);
    return modalRef;
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/modal.service.ts